// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","wrapper":"timeline-module__wrapper___12QdF"};